<template>
  <a-modal
    title="审核统计"
    :visible="visible"
    :footer="null"
    :maskClosable="false"
    @cancel="handleCancel"
    width="500px"
  >
    <a-spin :spinning="loading">
      <a-row :gutter="24" style="margin-top: 20px">
        <a-col :span="12">
          <a-card size="small">
            <a-statistic
              title="待审核数"
              :value="statisticsData.waitNum || 0"
              :value-style="{ color: '#ff4d4f' }"
            />
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card size="small">
            <a-statistic
              title="已审核数"
              :value="statisticsData.passNum || 0"
              :value-style="{ color: '#52c41a' }"
            />
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
    <div style="text-align: right; margin-top: 20px">
      <a-button @click="handleCancel">关闭</a-button>
    </div>
  </a-modal>
</template>

<script>
import { getWithdrawalCount } from '@/api/pressure/fund'

export default {
  name: 'AuditStatisticsModal',
  data() {
    return {
      visible: false,
      loading: false,
      statisticsData: {
        waitNum: 0,
        passNum: 0,
      },
      queryParam: {},
    }
  },
  methods: {
    init(queryParam) {
      this.queryParam = queryParam || {}
      this.visible = true
      this.loadStatistics()
    },
    handleCancel() {
      this.visible = false
      this.statisticsData = {
        waitNum: 0,
        passNum: 0,
      }
    },
    loadStatistics() {
      this.loading = true
      const params = {
        ...this.queryParam,
        pageNum: 1,
        pageSize: 10,
      }
      getWithdrawalCount(params)
        .then((res) => {
          if (res.success && res.data) {
            this.statisticsData = {
              waitNum: res.data.waitNum || 0,
              passNum: res.data.passNum || 0,
            }
          } else {
            this.$message.error(res.message || '获取统计数据失败')
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

